import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'react-relay';
import Offers from '../Offers/Offers';
import { GamingQuery } from './__generated__/GamingQuery.graphql';
import { PROMOTION_TAG } from 'utils/offers';

export interface Props {}

export const QUERY = graphql`
  query GamingQuery {
    gaming: cashbacks(input: { requiredTags: ["gaming"] }) {
      ...Offers_offers
    }
    gamingPromos: cashbacks(input: { requiredTags: ["gaming", "promo"] }, first: 1) {
      ...OfferPromoBanner_promos
    }
  }
`;

const Gaming: React.FC<Props> = () => {
  const data = useLazyLoadQuery<GamingQuery>(
    QUERY,
    {},
    {
      fetchPolicy: 'store-or-network',
    },
  );

  return data.gaming ? (
    <Offers
      staticCategory={{ name: 'Gaming', tag: 'gaming' }}
      offersRef={data.gaming}
      promosRef={data.gamingPromos}
      hideCategories
      offerType="gaming"
    />
  ) : (
    <p>We are having trouble loading gaming offers at the moment.</p>
  );
};

export default Gaming;
